import { render, staticRenderFns } from "./page-loader.vue?vue&type=template&id=0466dc45&scoped=true&lang=pug"
import script from "./page-loader.vue?vue&type=script&lang=ts"
export * from "./page-loader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0466dc45",
  null
  
)

export default component.exports